import cleanedFilename from '~/util/cleanedFilename';

export default {
  IBAN_FIELD: `${cleanedFilename(__filename)}-iban-field`,
  IBAN_FIELD_LABEL: `${cleanedFilename(__filename)}-iban-field-label`,
};
